import { camelCase, get } from '../lib/lodash';

const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const camelizeKeys = (value) => {
  if (Array.isArray(value)) {
    return value.map(camelizeKeys);
  }
  if (!isPlainObject(value)) {
    return value;
  }
  const out = {};
  Object.keys(value).forEach((key) => {
    const nextKey = /^\d+$/.test(key) ? key : camelCase(key);
    out[nextKey] = camelizeKeys(value[key]);
  });
  return out;
};

const asAuthorList = (row) => {
  const authors = get(row, 'authors');
  if (Array.isArray(authors) && authors.length) {
    return authors;
  }
  const user = get(row, 'user');
  if (user) {
    return [user];
  }
  return Array.isArray(authors) ? authors : [];
};

const withRealmIncludes = (row) => {
  const realm = get(row, 'realm');
  if (!realm || typeof realm !== 'object') {
    return realm;
  }
  return {
    ...realm,
    parent: realm.parent || row.realmParent || null,
    tier: realm.tier || row.realmTier,
  };
};

// Search returns lockedBy as null or one user. A normal assessment include
// is an array, and the list calls .some() / reads lockedBy.0 on that array.
const asLockedByList = (row) => {
  const lockedBy = get(row, 'lockedBy');
  if (Array.isArray(lockedBy)) {
    return lockedBy;
  }
  if (isPlainObject(lockedBy)) {
    return [lockedBy];
  }
  return [];
};

// search/assessments is not JSON:API. Lift the baked-in includes into the
// camelCase shape the list already uses (authors, realm.parent, startDate).
// High-level `scores` are not on this endpoint yet — pass them through so
// list rows keep rendering them when the API adds them.
export const mapSearchAssessment = (row) => {
  if (!row || typeof row !== 'object') {
    return row;
  }
  const camel = camelizeKeys(row);
  return {
    ...camel,
    authors: asAuthorList(camel),
    realm: withRealmIncludes(camel),
    scores: camel.scores,
    lockedBy: asLockedByList(camel),
  };
};

export const mapSearchAssessments = (raw) => {
  const rows = Array.isArray(raw) ? raw : get(raw, 'data', []);
  return (rows || []).map(mapSearchAssessment);
};
